import { IPublishedGiftCard } from 'components/gift_card_list/published_gift_cards/published_gift_cards.types';

export default (giftCard: IPublishedGiftCard): boolean => {
  const inventory = String(giftCard.inventory);

  const parts = inventory.split('/');

  return parseInt(parts[0]) < 1;
};
